export const AUTH = "auth";